import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/productCategory/importer/productCategoryImporterActions'

export default importerReducers(actions)
